import { ChevronLeftIcon } from '@approvalmax/ui';
import { Button, ButtonProps, Grid, Text, useConfirmation } from '@approvalmax/ui/src/components';
import { memo, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import { useCompanyIdBasedOnUrl } from 'shared/hooks/useCompanyIdBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { messages } from './BackButton.messages';

export const BackButton = memo(() => {
    const { push } = useHistory();
    const { companyId } = useCompanyIdBasedOnUrl();
    const form = useFormContext();
    const to = getPath(Path.walletsKyc, companyId);
    const { isDirty } = form.formState;

    const { confirmation } = useConfirmation({
        confirmButtonColor: 'blue80',
        cancelButtonMessage: messages.leaveWizardConfirmationCancel,
        confirmButtonMessage: messages.leaveWizardConfirmationConfirm,
        confirmMessage: (
            <Grid gap={24}>
                <span>{messages.leaveWizardConfirmationTitle}</span>

                <Text font='body' fontSize='medium' fontWeight='regular'>
                    {messages.leaveWizardConfirmationMessage({ br: <br /> })}
                </Text>
            </Grid>
        ),
    });

    const handleClick = useCallback<NonNullable<ButtonProps['onClick']>>(
        (event) => {
            if (!isDirty) {
                return;
            }

            event.preventDefault();

            void confirmation()
                .then(() => {
                    push(to);
                })
                .catch(() => {});
        },
        [confirmation, isDirty, push, to]
    );

    return (
        <Button
            color='midnight40'
            size='small'
            startIcon={<ChevronLeftIcon />}
            as={Link}
            to={to}
            onClick={handleClick}
            variant='outline'
        >
            {messages.back}
        </Button>
    );
});

BackButton.displayName = 'BackButton';
